import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import AuthLayout from "../components/common/AuthLayout";

function getError(error) {
  if (!error.response)
    return error.message === "Network Error"
      ? "Unable to reach the API. Check that the backend is running on localhost:5000, then restart React. Check Network for the request URL."
      : error.message || "Unable to connect.";
  const data = error.response.data;
  return (
    data?.message || data?.error || "Login failed. Check your credentials."
  );
}
export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const notice = location.state?.registered
    ? "Account created successfully. Sign in to continue."
    : "";

  async function onSubmit(e) {
    e.preventDefault();
    setError("");
    if (!identifier.trim() || !password)
      return setError("Enter your username/mobile and password.");
    setLoading(true);
    try {
      await login({ identifier, password });
      const from = location.state?.from;
      navigate(
        typeof from === "string" &&
          from.startsWith("/") &&
          !from.startsWith("//")
          ? from
          : "/game",
        { replace: true },
      );
    } catch (err) {
      setError(getError(err));
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthLayout
      eyebrow="WELCOME BACK"
      title="Sign in to your account"
      subtitle="Access your dashboard and continue playing."
    >
      {notice && (
        <div className="auth-alert success" role="status">
          {notice}
        </div>
      )}
      {error && (
        <div className="auth-alert error" role="alert">
          {error}
        </div>
      )}
      <form onSubmit={onSubmit} className="auth-form">
        <label htmlFor="identifier">Username or mobile number</label>
        <div className="auth-input-wrap">
          <span className="field-icon">◎</span>
          <input
            id="identifier"
            type="text"
            autoComplete="username"
            placeholder="Enter username or mobile"
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            required
          />
        </div>
        <label htmlFor="login-password">Password</label>
        <div className="auth-input-wrap">
          <span className="field-icon">♢</span>
          <input
            id="login-password"
            type={showPassword ? "text" : "password"}
            autoComplete="current-password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button
            type="button"
            className="show-password"
            onClick={() => setShowPassword((x) => !x)}
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? "Hide" : "Show"}
          </button>
        </div>
        <button className="auth-submit" type="submit" disabled={loading}>
          {loading ? "Signing in…" : "Sign in"}{" "}
          <span aria-hidden="true">→</span>
        </button>
      </form>
      <p className="auth-switch">
        New to Chicken Road? <Link to="/register">Create an account</Link>
      </p>
    </AuthLayout>
  );
}
